const theme = {
  colors: {
    background: "#191934",
    backgroundFaded: "#231F43",

    primary: "#1E75FB",
    secondary: "#40CC7F",

    orange: "#F77501",
    blue: "#1E75FB",
    pink: "#EC0182",
    indigo: "#8D18E4",
    green: "#40CC7F",

    gray1: "#1F1F1F",
    gray2: "#212229",
    gray3: "#181B23",
  },
  gradients: {
    orange: `linear-gradient(to bottom right, #ff4b1f, #FFAF1E)`,
    blue: `linear-gradient(to bottom right, #2a5298, #1E75FB)`,
    pink: `linear-gradient(to bottom right, #D1007B, #F11712)`,
    indigo: `linear-gradient(to bottom right, #7B01D5, #d04ed6)`,
    theme: `linear-gradient(to bottom right, #1E75FB, #40CC7F)`,
  },
};

export default theme;

export const navbarHeight = 80;
export const roundness = {
  card: 10,
  button: 20,
};

const stackTop = 990;
export const stack = {
  navigationBar: stackTop,
  contactFAB: stackTop,
  toast: stackTop,
  spinner: stackTop,
  dialog: stackTop + 2,
  backdrop: stackTop + 1,
};

export const styles = {
  ctaButton: (hover) => ({
    padding: 10,
    borderStyle: "solid",
    borderWidth: "medium",
    borderColor: "white",
    backgroundImage: hover ? theme.gradients.theme : "none",
    borderRadius: roundness.button,
    width: "130px",
    backgroundColor: "transparent",
    fontWeight: hover ? "bold" : "normal",
    color: hover ? theme.colors.background : "white",
    cursor: "pointer",
  }),
  sectionHeading: {
    borderStyle: "solid none none none",
    borderWidth: navbarHeight * 2,
    borderColor: "#ffffff00",
    fontSize: "25px",
    fontWeight: "bold",
    color: "white",
  },
  videos: () => {
    const cardWidth = 270;
    const spacing = 20;
    const maxNumberOfColumns = 4;
    const gridWidth =
      cardWidth * maxNumberOfColumns + (spacing * maxNumberOfColumns - 1);

    return {
      cardWidth,
      spacing,
      maxNumberOfColumns,
      gridWidth,
    };
  },
};
